import { useUserData } from './user-data'
import { useUserActions } from './user-actions'
import { useMemo } from 'react'

const useUser = () => {
	const user = useUserData()
	const actions = useUserActions()

	return useMemo(() => [user, actions], [user, actions])
}

export default useUser
